import { render } from "./VisitorLogHistoryTable.vue?vue&type=template&id=2258a9dd&scoped=true"
import script from "./VisitorLogHistoryTable.vue?vue&type=script&lang=js"
export * from "./VisitorLogHistoryTable.vue?vue&type=script&lang=js"

import "./VisitorLogHistoryTable.vue?vue&type=style&index=0&id=2258a9dd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2258a9dd"]])

export default __exports__